import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../../services/AppContext/appProvider";

type ModalTermsProps = {
  // TODO: add props here
};

const ModalTerms: React.FC<ModalTermsProps> = (props) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const location = useLocation();
  const nav = useNavigate();
  const { setCurrentPage } = useContext(UserContext);

  useEffect(() => {
    if (location.state?.showTerms) {
      setShowModal(true);
    } else {
      setCurrentPage("");
      setShowModal(false);
    }
  }, [location.state]);

  function closeModal() {
    setCurrentPage("");
    const urlParams = new URLSearchParams(location.search);
    const newUrl = location.pathname + "?" + urlParams.toString();
    nav(newUrl, { state: { ...location.state, showTerms: false } });
  }

  if (!showModal) {
    return null;
  }

  return (
    <div className="modal modal-open !overflow-hidden" onClick={closeModal}>
      <div
        className="modal-box max-h-none max-w-2xl"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside the modal box
      >
        <div className="modal-action">
          <label
            className="btn btn-circle btn-sm absolute right-2 top-2"
            onClick={closeModal}
          >
            ✕
          </label>
        </div>
        <div className="content max-h-[80vh] overflow-y-auto">
          <h2 className="mb-4 text-xl font-bold">TERMS & CONDITIONS</h2>
          <p>Last Updated: 15 February 2025</p>
          <p>
            Welcome to Friyay! These Terms & Conditions ("Terms") govern your
            access to and use of Friyay's website, auctions, and services. By
            accessing, bidding, purchasing, or using Friyay in any way, you
            agree to abide by these Terms.
          </p>
          <p>
            If you do not agree with these Terms, please do not use the Friyay
            platform.
          </p>
          <h3 className="mt-4 text-lg font-semibold">
            1. Eligibility & User Agreement
          </h3>
          <p>
            You must be at least 18 years old and legally capable of entering
            into a binding contract.
          </p>
          <p>
            Friyay operates exclusively in South Africa and does not accept
            international bidders or buyers.
          </p>
          <p>
            By using Friyay, you confirm that you meet these eligibility
            requirements.
          </p>
          <h3 className="mt-4 text-lg font-semibold">2. How Friyay Works</h3>
          <p>Users must purchase Blitz credits to participate in auctions.</p>
          <p>
            Each bid extends the timer by 10 seconds; when the timer reaches
            zero, the highest bidder wins or to ensure value for our users,
            auctions automatically close when bids reach 90% of the retail
            price, with the last bidder winning the right to purchase the item
            at the final bid amount.
          </p>
          <p>
            Winning bidders are not obligated to purchase the item they won in
            the auction, though they retain the right to do so at the final bid
            amount.
          </p>
          <p>
            Blitz credits are non-refundable and cannot be exchanged for cash.
          </p>
          <p>
            Users can utilize our BidBuddy automated bidding feature to place
            bids on their behalf, allowing for participation in multiple
            auctions simultaneously.
          </p>
          <p>
            Winning an auction does not mean the item is free — it secures the
            right to purchase the item at the final bid amount.
          </p>
          <p>
            Additional fees such as shipping and handling may apply and will be
            clearly displayed before checkout.
          </p>
          <p>
            Friyay does not guarantee product availability for any auction at a
            specific time and reserves the right to modify or remove auctions
            without prior notice.
          </p>
          <h3 className="mt-4 text-lg font-semibold">3. Payments & Fees</h3>
          <p>
            Friyay accepts payments via the Yoco payment gateway (Debit Cards,
            Credit Cards, Instant EFT, AMEX).
          </p>
          <p>Transaction fees may apply and will be displayed at checkout.</p>
          <p>
            If a payment fails, Friyay reserves the right to block access to the
            user account until full payment (including any penalties) is
            received.
          </p>
          <p>
            Friyay may withhold any outstanding deliveries until full payment is
            made.
          </p>
          <p>
            Friyay reserves the right to withhold products until payment is
            cleared.
          </p>
          <h3 className="mt-4 text-lg font-semibold">4. Shipping & Delivery</h3>
          <p>Delivery is only available within South Africa.</p>
          <p>Estimated delivery time is between 3 to 14 business days.</p>
          <p>
            Friyay currently offers free shipping on all orders within South
            Africa. This policy may be subject to change, and any updates to
            shipping costs will be communicated to users in advance.
          </p>
          <p>
            A tracking link will be emailed to the customer once the order is
            dispatched.
          </p>
          <h3 className="mt-4 text-lg font-semibold">5. Returns & Refunds</h3>
          <h4 className="text-md mt-2 font-semibold">
            5.1 Standard Returns Policy (Non-Faulty Items)
          </h4>
          <p>
            A customer may return an item within 30 days of receipt under the
            following conditions:
          </p>
          <p>
            The return request must be submitted via our contact form within 3
            days of receiving the item.
          </p>
          <p>
            The item must be in its original packaging, unused, and include all
            original accessories and documentation.
          </p>
          <p>Non-returnable items include (but are not limited to):</p>
          <ul className="list-inside list-disc">
            <li>
              Swimwear, lingerie, underwear, cosmetics, personal hygiene items,
              foodstuffs, supplements, jewelry, electronic devices (such as
              earphones), adult products, and medical equipment.
            </li>
          </ul>
          <h4 className="text-md mt-2 font-semibold">
            5.2 Faulty or Incorrect Items
          </h4>
          <p>
            If Friyay ships the wrong or defective item, we will cover return
            shipping costs.
          </p>
          <p>
            If an item is faulty due to user error or misuse, the customer must
            cover the return shipping cost.
          </p>
          <p>
            Refunds are issued via EFT only. No store credits or replacements
            will be provided.
          </p>
          <p>
            Any damage must be reported in writing via our contact form within 3
            days of receiving the item for the claim to be valid.
          </p>
          <h3 className="mt-4 text-lg font-semibold">
            6. Auction Bidding Rules
          </h3>
          <p>
            Once a bid is placed, it cannot be canceled, however users can
            choose not to buy a product that they have bid on.
          </p>
          <p>
            All bids must be placed in predetermined increments set by Friyay;
            custom bid amounts are not permitted.
          </p>
          <p>
            Users are limited to placing one active bid at a time, unless
            utilizing the BidBuddy automated bidding feature.
          </p>
          <p>
            Friyay does not guarantee the accuracy of the BidBuddy feature and
            is not responsible for any errors related to automated bidding.
          </p>
          <p>
            Unauthorized bidding software is prohibited — violators may be
            immediately disqualified from Friyay auctions.
          </p>
          <p>
            Users can earn free Blitz credits through various platform
            activities including profile completion, daily check-ins, and
            successful friend referrals.
          </p>
          <p>
            Friyay may offer free Blitz as part of promotions, but the number of
            free Blitz awarded is at Friyay's sole discretion.
          </p>
          <p>
            Users are solely responsible for their spending, bidding, and
            purchasing on Friyay. Friyay is not responsible for excessive or
            unintended bidding.
          </p>
          <p>
            Users may not resell products obtained through Friyay without
            written consent.
          </p>
          <h3 className="mt-4 text-lg font-semibold">7. Dispute Resolution</h3>
          <h4 className="text-md mt-2 font-semibold">
            7.1 Payment Disputes & Chargebacks
          </h4>
          <p>
            If a payment dispute arises, Friyay reserves the right to suspend
            the user's account until the dispute is resolved.
          </p>
          <p>
            If a chargeback is initiated by the user without prior contact with
            Friyay, the account may be permanently banned.
          </p>
          <h4 className="text-md mt-2 font-semibold">7.2 Arbitration Clause</h4>
          <p>
            Any legal disputes that cannot be resolved informally will be
            submitted to binding arbitration under the Arbitration Act, 1965
            (Act No. 42 of 1965).
          </p>
          <p>
            Arbitration will be conducted by the Arbitration Foundation of
            Southern Africa (AFSA) under its commercial arbitration rules.
          </p>
          <p>
            Any arbitration ruling may be enforced in a South African court of
            law.
          </p>
          <h3 className="mt-4 text-lg font-semibold">
            8. Account Termination & Suspension
          </h3>
          <p>
            Friyay may suspend or terminate an account without prior notice if:
          </p>
          <ul className="list-inside list-disc">
            <li>The user violates these Terms & Conditions.</li>
            <li>
              The user's actions are potentially illegal, fraudulent, or harmful
              to Friyay or other users.
            </li>
            <li>The user has outstanding payments due to Friyay.</li>
            <li>
              Providing the service is no longer technically or commercially
              feasible.
            </li>
            <li>
              The user is found to be engaging in fraudulent activities such as
              multiple accounts, collusion, or unauthorized automated bidding.
            </li>
          </ul>
          <h3 className="mt-4 text-lg font-semibold">
            9. Liability & Technical Issues
          </h3>
          <p>
            Friyay is not liable for technical errors, auction malfunctions, or
            payment gateway failures beyond its control.
          </p>
          <p>
            If a system error affects an auction, Friyay reserves the right to
            cancel or adjust bids at its discretion.
          </p>
          <p>
            Users agree that Friyay does not guarantee uninterrupted access to
            the platform.
          </p>
          <p>
            Friyay is not responsible for third-party abuse or manipulation of
            the platform.
          </p>
          <p>
            Friyay will not be held liable for force major events such as
            natural disasters, government actions, or network failures affecting
            service delivery.
          </p>
          <h3 className="mt-4 text-lg font-semibold">
            10. Privacy & Data Protection
          </h3>
          <p>
            Friyay is committed to protecting your personal information under
            the Protection of Personal Information Act (POPIA).
          </p>
          <p>
            All transactions are processed securely via Yoco's payment gateway.
          </p>
          <p>
            User data will not be sold or shared with third parties, except as
            required by law or to process payments.
          </p>
          <p>
            Users are responsible for maintaining the confidentiality of their
            account login details.
          </p>
          <p>For more details, review our Privacy Policy.</p>
          <h3 className="mt-4 text-lg font-semibold">
            11. Amendments to These Terms
          </h3>
          <p>Friyay reserves the right to update these Terms at any time.</p>
          <p>
            Users will be notified of significant changes via email or a website
            notice.
          </p>
          <p>
            Continued use of Friyay after modifications constitutes acceptance
            of the revised Terms.
          </p>
          <h3 className="mt-4 text-lg font-semibold">
            12. Supplier Partnerships
          </h3>
          <p>
            Friyay welcomes partnerships with suppliers of premium products who
            meet our quality standards. Interested suppliers should contact our
            customer service team for partnership opportunities.
          </p>
          <h3 className="mt-4 text-lg font-semibold">
            13. Contact Information
          </h3>
          <p>
            For any inquiries or support requests, please contact Friyay via our
            contact form.
          </p>
          <p>
            By using Friyay, you acknowledge and agree to these Terms &
            Conditions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ModalTerms;
